export default {
	getCollaborators: () => (policies, collaborators) => {
		if (!policies || !collaborators) return [];
		return (
			collaborators.filter(collaborator => {
				return policies.some(policy => {
					return (
						collaborator.user_id === policy.user_id &&
						collaborator.policy_profile_id === policy.policy_profile_id
					);
				});
			}) ?? []
		);
	},
	getImageUrl: () => item => {
		if (item == null || item.image == "/services/avatar/M./" || item.image == null) {
			return "https://sinao.app/services/avatar/Unknown/M.";
		}

		if (item?.image) {
			const { image } = item;

			if (image.includes("http")) {
				return image;
			} else if (image.includes("/services/")) {
				return `https://sinao.app${image}`;
			} else {
				return `https://sinao-prod-storage.s3.eu-west-3.amazonaws.com/${image}`;
			}
		} else if (item?.firstname && item?.lastname) {
			return `https://sinao.app/services/avatar/${item.firstname}${item.lastname}/${item.firstname[0]}${item.lastname[0]}`;
		}
	},
	stringToHSLColor:
		() =>
		(inputString, s = 70, l = 60) => {
			let hash = 0;
			for (let i = 0; i < inputString.length; i++) {
				hash = inputString.charCodeAt(i) + ((hash << 5) - hash);
			}

			const hue = hash % 360;
			return `hsl(${hue}, ${s}%, ${l}%)`;
		},
	sorted_cases(state) {
		const cases = state.loadedCases ?? [];
		return [...cases].sort((a, b) =>
			a.organization.name.localeCompare(b.organization.name, "fr", { sensitivity: "base" })
		);
	},
	loaded_apps(state) {
		return state.loadedApps;
	},
	loaded_policies(state) {
		return state.loadedPolicies;
	},
	loaded_cases(state) {
		return state.loadedCases;
	},
	license_plans(state) {
		return state.licensePlans;
	},
	showPartnerAppsSelector(state) {
		return state.loadedCases && state.loadedCases.length > 0;
	},
	pageSize(state) {
		return state.pageSize;
	},
	totalRowsLicense(state) {
		return state.totalRowsLicense;
	}
};
